const externalLinks = {
    clientLogin: "https://manage.thepromorama.com",
    adminLogin: "https://manage.thepromorama.com/login",
    promoterLogin: "https://app.thepromorama.com",
    supervisorLogin: "https://app.thepromorama.com"
}

export default externalLinks;